export default __webpack_public_path__ + "static/media/successful.ff41daa4.svg";